import { func } from 'prop-types';
import React, { PureComponent } from 'react';

import { atgCalendarHighlight } from 'calendar/proptypes';
import Button from 'shared/components/button/Button';
import Star from 'shared/components/icon/Star';
import { formatCalendar } from 'shared/utils/dateUtils';
import { getText } from 'shared/utils/Text';

export default class AtgHighlightItem extends PureComponent {
  static propTypes = {
    highLight: atgCalendarHighlight.isRequired,
    onClick: func.isRequired,
  };

  onClick = () => {
    const {
      highLight: { betParams },
      onClick,
    } = this.props;
    onClick(betParams);
  };

  render() {
    const {
      highLight: {
        trackName,
        betParams: { betType },
        startTime,
        jackpotAmount,
      },
    } = this.props;

    return (
      <li className="atg-highlight-item">
        <Button
          onClick={this.onClick}
          className={`block-button block-button--bet bg-${betType}`}
        >
          <div className="block-button__inner">
            <span className="block-button__left">{betType}</span>
            {jackpotAmount && (
              <span className="block-button__jackpot">
                <Star className="white" />
                <span className="jackpot-amount">
                  {getText('calendar-jackpot-button-value', jackpotAmount)}
                </span>
              </span>
            )}
            <span className="block-button__right">
              {trackName},{' '}
              {formatCalendar(startTime, { showTimeForToday: true })}
            </span>
          </div>
        </Button>
      </li>
    );
  }
}
